var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "warningSignRedOutlined",
  "use": "warningSignRedOutlined-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warningSignRedOutlined\">\n<path d=\"M10.0007 5.4085L16.2757 16.2502H3.72565L10.0007 5.4085ZM10.0007 2.0835L0.833984 17.9168H19.1673L10.0007 2.0835Z\" fill=\"#B72D2D\" />\n<path d=\"M10.834 13.7502H9.16732V15.4168H10.834V13.7502Z\" fill=\"#B72D2D\" />\n<path d=\"M10.834 8.75016H9.16732V12.9168H10.834V8.75016Z\" fill=\"#B72D2D\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol